<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('select_company') }}</li>
        </ol>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div v-if="($store.state.companies.length==0)" class="alert alert-primary" role="alert">
                        {{$t('you_do_not_have_register_company_please_contact_to_khmer_learner_supporter')}}
                    </div>
                    <div v-else>
                        <div class="row">
                            <div class="col-md-12 p-3" style="text-transform: uppercase; font-weight: 600; color: #0856ab;">{{$t('select_a_company_that_you_want_to_work')}}</div>
                        </div>
                        <div class="row">
                            <div v-for="(ret, index) in $store.state.companies" :key="index" class="col-md-3">
                                <div class="card card-over" @click="selectCompany(ret)">
                                    <div class="card-body">
                                        <div class="d-flex align-items-center">
                                            <img :src="imageUrl(ret.Logo)" variant="info" class="mr-3 rounded" style="width: 50px; height: 50px;"/>
                                            <div>
                                                <div style="font-weight: 600; font-size: 14px;color: #0856ab;">{{ret.Name}}</div>
                                                <div>{{getVatTin(ret)}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            selectCompany(ret) {
                localStorage.setItem("compx", JSON.stringify(ret));
                this.$store.state.company = ret;

                this.$api().post("exchangerate/latest", { CompanyId: ret.Id }).then(res => {
                    if (res.status == 200) {
                        const data = res.data.Data;
                        localStorage.setItem("exchange", JSON.stringify(data));
                        this.$store.state.exchange = data;
                    }
                });

                this.$router.push('/');
            },
            imageUrl(logo) {
                if(logo != null)
                    return this.$base() + 'image/logo/' + logo;
                else return '/img/no-logo.png';
            },
            getVatTin(item){
                return item.TinHead==null?'0000':item.TinHead + '-' + (item.VatTin==null?'000000000':item.VatTin);
            }
        }
    }
</script>
<style scoped>
    .card-over:hover{
        background-color: #cce5ff;
        border-color: #b8daff;
        cursor: pointer;
    }
</style>